//export const SERVER_IP='http://localhost:8080';
 export const SERVER_IP='http://api.pegatv.vn';
//export const SERVER_IP='192.168.59.168:8080';

export const APP_ID = "3b10609dc58d37251d7bf381489626bb";
export const APP_SECRET = "63e65664fad64ab412e03191c42f01fa";



// WEBPACK FOOTER //
// ./src/constants/Config.js